import { Typographies } from '@/theme';
import Colors from '@/theme/constants/Colors';
import { styled } from '@mui/material';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export const RootStyled = styled('div')<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ theme }) => ({
  background: Colors.PRIMARY_LIGHT,
  color: theme.palette.primary.main,
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: Typographies.FONT_WEIGHT_H4,
  cursor: 'pointer',
  maxWidth: 200,
  minHeight: 100,
}));
